<div class="mt-10">
  <div class="logos center">
    <img src="assets/logo-bioref.svg" alt="InsightDX" />
  </div>
  <div class="center login-body">
    @if (loginWebsite) {
      @if (allowPrivateNetworkAccess) {
        <iframe
          id="iframe"
          [src]="loginWebsite"
          class="iframe"
          allow="local-network-access *"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      } @else {
        <iframe
          id="iframe"
          [src]="loginWebsite"
          class="iframe"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      }
    }
  </div>
  @if ((message$ | async)?.message; as message) {
    <div class="center">
      <span class="announcement">{{ message }}</span>
    </div>
  }
  <div class="contact">
    <span>Customer Service 800.229.5227</span>
    <br />
    <span>Technical Support 800.229.5227 x8462</span>
  </div>
</div>
